<div [formGroup]="parentForm" class="input-container">
    <div class="wire-details-header">Optional wire details</div>
    <div id="optional_wire_details">
        <mm-banners [bannerText]="[warningDescription]" [type]="'warning'"
            data-testid="wireRecipientInterimEscrowWarning_wires">
        </mm-banners>
        <div class="transmission-text-area">
            <label *ngIf="!isIrsAba" for="transmission-notes" class="transmission-notes-text" data-testid="transmission-notes-label" [class.error-text]="hasError">Transmission notes for receiving banks 
                <mm-tooltip [position]="'right'" [containsLink]="false">
                    <tooltip-content>
                        <div>{{transmissionNotesTooltipContent}}</div>
                    </tooltip-content>
                    <tooltip-trigger-element>
                        <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
                    </tooltip-trigger-element>
                </mm-tooltip>
            </label>
            <label *ngIf="isIrsAba" for="transmission-notes" class="transmission-notes-text" data-testid="transmission-notes-label" [class.error-text]="hasError">Transmission notes for tax remittance 
                <mm-tooltip [position]="'right'" [containsLink]="false">
                    <tooltip-content>
                        <div>{{irsAbaTransmissionNotesTooltipContent}}</div>
                    </tooltip-content>
                    <tooltip-trigger-element>
                        <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
                    </tooltip-trigger-element>
                </mm-tooltip>
            </label>
        </div>
        <div class="container">
            <div class="columns textarea">
                <textarea [(ngModel)]="textAreaValue" (blur)="trimWhiteSpace()" formControlName="transmissionNotes"
                    [class.error-input]="hasError" id="transmission-notes"
                    data-testid="transmissionNotesTextArea" name="transmission-notes" rows="10" maxlength={{maxLength}}
                    (input)="limitLines($event, 10)">
                </textarea>
                <div id="textarea-messages">
                        <span *ngIf="hasError" class="alert-text"
                        data-testid="transmissionNotesValidationError">
                        {{transmissionNotesValidationErrorIso}}</span>
                    <div></div>
                    <span id="character-count">{{transmissionNotes?.value?.length}}/{{maxLength}}</span>
                </div>
            </div>
            <div class="columns content">
                <div class="content-container">
                    <span>Do not include in transmission notes:</span>
                    <ul class="tramission-notes-list">
                        <li class="tramission-notes-list-item">Instructions for your Schwab Service team</li>
                        <li class="tramission-notes-list-item">Schwab account holder information (account name, number, and address)</li>
                        <li class="tramission-notes-list-item">Receiving bank account numbers that already should have been entered</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
